<template>
    <div class="slideout-inner" id="products-from-order-event">
      <div class="slideout-close" @click="$parent.closeSlideout()">
        <i class="fas fa-times"></i>
      </div>
      <div class="template-header-wrapper">
        <h3> Comenzi </h3>
        <div class="template-header">
          <div class="template-left-side">
            <div class="template-search-container">
              <div class="search-form">
                <input
                class="search-input"
                type="search"
                :placeholder="$t('placeholder.cautaProdus')"
                name="q"
                v-model="search"
                id="product-search-order"
                autocomplete="off"
                @input="searchProductsFromOrder()">
                <span class="focus-input"></span>
                <span class="symbol-input">
                  <i class="fas fa-search"></i>
                </span>
              </div>
            </div>
            <div class="template-dropdown-group">
              <div class="template-dropdown-button" :key="componentFilterIdKey" id="filter-id">
                <b-dropdown id="dropdown-form1" text="NR" ref="dropdown">
                  <b-dropdown-form class="innner-dropdown-content">
                    <b-form-checkbox v-for="(order,index) in ordersAll" :key="index"
                    @change="addRemoveFilter('id', order.id)">
                    {{order.id}}
                  </b-form-checkbox>
                  <!-- <span class="close-dropdown-filter" @click="closeFiltersDropdown('filter-id')">
                    <i class="far fa-times-circle"></i>
                  </span> -->
                </b-dropdown-form>
              </b-dropdown>
              <span class="template-reset-filter" @click="resetFilter('id', 'componentFilterIdKey')"
              v-if="orderFilter['id'].length > 0">
              <i class="fas fa-sync-alt"></i>
            </span>
          </div>
          <div class="template-dropdown-button" :key="componentFilterDateKey" id="filter-date">
            <b-dropdown id="dropdown-form2" text="Data" ref="dropdown">
              <b-dropdown-form class="innner-dropdown-content">
                <b-form-checkbox v-for="(date,index) in orderDates()" :key="index"
                @change="addRemoveFilter('created_at', date)">
                {{date}}
              </b-form-checkbox>
              <!-- <span class="close-dropdown-filter" @click="closeFiltersDropdown('filter-date')">
                <i class="far fa-times-circle"></i>
              </span> -->
            </b-dropdown-form>
          </b-dropdown>
          <span class="template-reset-filter" @click="resetFilter('created_at','componentFilterDateKey')"
          v-if="orderFilter['created_at'].length > 0">
          <i class="fas fa-sync-alt"></i>
        </span>
      </div>
      <div class="template-dropdown-button" :key="componentFilterObjeKey" id="filter-objective">
        <b-dropdown id="dropdown-form3" text="Obiectiv" ref="dropdown">
          <b-dropdown-form class="innner-dropdown-content">
            <!-- <b-form-checkbox v-for="(objective,index) in orderObjectives2()" v-model="objective.status" :key="index" @change="addRemoveFilter('objective', objective)" v-if="objective && objective !=null">
            {{objective.objective}}
          </b-form-checkbox>-->
          <b-form-checkbox v-for="(objective,index) in orderObjectives()"
          v-model="objective.status" :key="index"
          @change="addRemoveFilter('objective', objective)"
          v-if="objective && objective !=null">
          {{objective}}
        </b-form-checkbox>
        <!-- <span class="close-dropdown-filter" @click="closeFiltersDropdown('filter-objective')">
          <i class="far fa-times-circle"></i>
        </span> -->
      </b-dropdown-form>
    </b-dropdown>
    <span class="template-reset-filter" @click="resetFilter('objective', 'componentFilterObjeKey')"
    v-if="orderFilter['objective'].length > 0">
    <i class="fas fa-sync-alt"></i>
  </span>
</div>
</div>
</div>
<div class="template-right-side">
  <div class="template-list-legend">
    <ul>
      <li>
        <span class="template-legend-dot dot-available">  </span>
        <p> Disponibile </p>
      </li>
      <!-- <li>
      <span class="template-legend-dot dot-reserved">  </span>
      <p> Rezervate </p>
    </li> -->
    <li>
      <span class="template-legend-dot dot-billed">  </span>
      <p> Facturate </p>
    </li>
    <li>
      <span class="template-legend-dot dot-ordered">  </span>
      <p> Comandate </p>
    </li>
  </ul>
  <div class="template-legend-alert">
    <i class="fas fa-exclamation-triangle"></i>
    <span> Numar necesar de produse indisponibil </span>
  </div>
</div>
</div>
<div class="template-collapse-all">
  <span @click="collapseAll()" class="collapse-all">
    <i class="fas fa-grip-lines"></i>
  </span>
</div>
</div>
      </div>
        <div class="template-inner-content">
            <div role="tablist" class="products_from" v-if="orders" :key="componentProductsKey">
                <div class="template-main-item" v-for="(order, index) in orders" :key="index">
                    <div class="template-item-heading">
                        <div class="template-checkbox-slot" :key="emitOrderRow">
                            <b-form-checkbox v-model="order.checked" @input="emitOrder(order.id, index)"
                                           >

                            </b-form-checkbox>
                        </div>
                        <div class="template-main-info" v-b-toggle="preventToggle ? false : 'collapse-order'+index"
                             @click="template = index">
                            <div class="template-order-nr">
                                <p> {{order.id}} </p>
                            </div>
                            <div class="template-gn-info">
                                <p> {{order.created_at}} </p>
                            </div>
                            <div class="template-gn-info template-order-obj">
                                <p> {{order.objective}} </p>
                            </div>
                            <div class="show-all-products">
                                <p class="show-every-order" v-if="isSearching"
                                   @click="showAllProductsFromOrder(index, order.id, $event)"> X </p>
                            </div>
                            <div class="template-collapse-icon">
                                <i class="fas fa-grip-lines"></i>
                            </div>
                        </div>
                    </div>
                    <b-collapse visible :id="'collapse-order'+index">
                        <div class="template-inner-accordion" :key="emitProductRow">
                            <div class="template-accordion-row"
                                 :class="product.qty_available <= product.qty_total - product.qty_billed ? 'template-row-warning' : '' "
                                 v-for="(product, indexProd) in order.products" :key="indexProd">
                                <div class="template-accordion-checkbox">
                                    <b-form-checkbox v-model="product.checked"
                                                     @input="emitProduct(order.id, product.id, true, product)"
                                                     class="hide-b-form-checbox-products-from-order"

                                    >

                                    </b-form-checkbox>
                                </div>
                                <div class="template-item-name">
                                    <h1 @click="toggleTargetProductCheckedStatus(order.id, product.id, indexProd)"> {{product.name}} </h1>
                                </div>
                                <div class="template-item-qty">
                                    <div class="template-input-qty">
                                        <input :data-product-can-be-added="product.qty_available <= product.qty_total - product.qty_billed ? false : true"
                                               :data-product="order.id + '-' + product.id"
                                               :data-product-active="index + '-' + indexProd"
                                               @click="activateQtyInput(index, indexProd)"
                                               @input="emitProduct(order.id, product.id, false, product)" type="number"
                                               v-model="product.qty_input" :data-warehouse-id="product.warehouse_id"
                                               :data-warehouse-name="getWarehousesById(product.warehouse_id).name"
                                               :data-warehouse-key="getWarehousesById(product.warehouse_id).key"/>
                                    </div>
                                    <div class="template-item-pending">
                                        <span class="billed-items"> {{product.qty_billed || 0 }} </span>
                                        <span class="ordered-items"> {{product.qty_total || 0 }} </span>
                                    </div>
                                </div>
                                <div class="template-item-price">
                                    <p> {{product.price | formatPrice }}</p>
                                </div>
                                <div class="template-item-status">
                                    <span class="available-items"> {{product.qty_available || 0 }} </span>
                                    <!-- <span class="reserved-items"> {{product.qty_reserved || 0 }} </span> -->
                                </div>
                            </div>
                        </div>
                    </b-collapse>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import ProductsService from '../api-services/products.service'
import OrdersService from '../api-services/orders.service'
import { EventBus } from '../main.js'

export default {
  name: 'ProductsFomOrder',
  props: [
    'client',
    'warehouses'
  ],
  data () {
    return {
      orders: [],
      ordersAll: [],
      orderFilter: {
        'id': [],
        'created_at': [],
        'objective': []
      },
      orderFilterKeys: ['id', 'created_at', 'objective'],
      orderDateFilter: [],
      orderObjectiveFilter: [],
      componentProductsKey: 0,
      componentFilterIdKey: 'id1',
      componentFilterDateKey: 'date1',
      componentFilterObjeKey: 'obj1',
      indexCount: 0,
      lastQtyActive: { orderIndex: 0, productIndex: 0 },
      search: null,
      ordersAfterSearch: [],
      searchOrders: [],
      visible: 0,
      preventToggle: false,
      showAllProductsFromOrderObject: [],
      template: null,
      isSearching: false,
      countHowManyTimes: 0,
      emitOrderRow: 0,
      emitProductRow: 'emitProductRow',
      checkedOrders: []
    }
  },
  watch: {
    client: function (val) {
      if (Number.isInteger(this.client.id)) {
        this.getUserOrders(this.client.id)
      }
    },
    search: function (newVal, oldVal) {
      if (newVal !== '') {
        this.isSearching = true
      } else {
        this.isSearching = false
      }
    }
  },
  mounted () {
    let vm = this
    EventBus.$on('clearUserOrders', (data) => {
      if (data) {
        this.orders = []
        this.ordersAll = []
      }
    })
    EventBus.$on('changeClientClearOrderFilter', (data) => {
      if (data) {
        this.orderFilter['created_at'] = []
        this.orderFilter['objective'] = []
        this.orderFilter['date'] = []
        this.componentProductsKey += 1
        this.componentFilterObjeKey += 1
        this.componentFilterDateKey += 1
        this.componentFilterIdKey += 1
      }
    })
    EventBus.$on('uncheckFromOrder', (data) => {
      let order = this.ordersAll.find(o => parseInt(o.id) === parseInt(data.orderId))
      let orderIndex = this.ordersAll.findIndex(o => parseInt(o.id) === parseInt(data.orderId))
      let productIndex = []

      order.products.forEach(function (product, index) {
        if (parseInt(product.id) === parseInt(data.productId)) {
          productIndex.push(index)
        }
      })
      this.ordersAll[orderIndex].checked = false
      this.markProductCheckAsFalse(productIndex, orderIndex, this.ordersAll)

      order = this.orders.find(o => parseInt(o.id) === parseInt(data.orderId))
      orderIndex = this.orders.findIndex(o => parseInt(o.id) === parseInt(data.orderId))
      productIndex = order.products.findIndex(prods => parseInt(prods.id) === parseInt(data.productId))
      this.markProductCheckAsFalse(productIndex, orderIndex, this.orders)
      // this.componentProductsKey += 1
    })

    document.getElementById('products-from-order-event').addEventListener('keydown', event => {
      if ((event.keyCode === 40 || event.keyCode === 38) && document.activeElement.getAttribute('data-product-active') !== null) {
        event.preventDefault()
        if (event.keyCode === 40) {
          let newproductIndex = vm.lastQtyActive.productIndex + 1
          if (window.$('[data-product-active=' + vm.lastQtyActive.orderIndex + '-' + newproductIndex + ']').length > 0) {
            vm.lastQtyActive.productIndex = newproductIndex
          }
        } else {
          vm.lastDataDiscountActive = vm.lastDataDiscountActive < 1 ? 0 : vm.lastDataDiscountActive - 1
          let newproductIndex = vm.lastQtyActive.productIndex - 1
          if (window.$('[data-product-active=' + vm.lastQtyActive.orderIndex + '-' + newproductIndex + ']').length > 0) {
            vm.lastQtyActive.productIndex = newproductIndex
          }
        }
        window.$('[data-product-active=' + vm.lastQtyActive.orderIndex + '-' + vm.lastQtyActive.productIndex + ']').focus().select()
      }
    })
  },
  methods: {
    toggleTargetProductCheckedStatus (orderId, productId, indexProd) {
      let order = this.orders.find(o => parseInt(o.id) === parseInt(orderId))
      let product = order.products.find(p => parseInt(p.id) === parseInt(productId))

      if (product.checked) {
        product.checked = false
      } else {
        product.checked = true
      }
      this.emitOrderRow += 1
    },
    markProductCheckAsFalse (productIndexArray, orderIndex, wich) {
      if (productIndexArray.length) {
        for (let i = 0; i < productIndexArray.length; i++) {
          wich[orderIndex].products[productIndexArray[i]].checked = false
        }
      }
    },
    // closeFiltersDropdown (id) {
    //   window.$('#' + id).click()
    // },
    collapseAll () {
      let vm = this
      for (let i = 0; i < this.orders.length; i++) {
        vm.$root.$emit('bv::toggle::collapse', 'collapse-order' + i)
      }
      let target = document.getElementsByClassName('collapse-all')
      if (this.checkedOrders.length) {
        this.checkedOrders.forEach(function (orderIndex) {
          vm.showOnCollapse(orderIndex)
        })
      } else {
        //
      }
      target[0].classList.toggle('collapsed')
    },
    hideFiltersDropdown () {
      this.$refs.dropdown.hide(true)
    },
    searchProductsFromOrder () {
      let vm = this
      this.applySearch()
      this.orderFilterKeys.forEach(function (element) {
        if (vm.orderFilter[element].length > 0) {
          vm.orders = vm.orders.filter(order => vm.orderFilter[element].includes(order[element]))
        }
      })
      this.componentProductsKey += 1
    },
    activateQtyInput (orderIndex, productIndex) {
      this.lastQtyActive = { orderIndex: orderIndex, productIndex: productIndex }
      window.$('[data-product-active=' + orderIndex + '-' + productIndex + ']').focus().select()
    },
    emitOrder (orderId, index) {
      let order = this.orders.find(o => parseInt(o.id) === parseInt(orderId))
      let vm = this
      let orderStatus = order.checked
      this.$parent.$refs.clientCompRef.selected_partner = this.$parent.$refs.clientCompRef.partners.find(x => x.id === order.partner.id)
      this.$parent.totalDiscountCheckbox = parseInt(order.show_total_discount) === 1
      this.$parent.discount = parseFloat(order.discount)
      order.products.forEach(function (product) {
        if (orderStatus === true) {
          vm.checkedOrders.push(index)
          vm.emitOrderRow = orderStatus
          if (product.qty_available >= product.qty_input && product.qty_input !== null) {
            product.checked = true
          } else {
            product.checked = false
          }
          vm.emitProductRow += 1
        } else {
          if (vm.checkedOrders.length) {
            let ordIndex = vm.checkedOrders.indexOf(index)
            if (ordIndex !== -1) vm.checkedOrders.splice(index, 1)
          }
          product.checked = false
          vm.emitOrderRow += 1
        }
        vm.showOnCollapse(index)
        vm.emitProduct(orderId, product.id, false, product, false)
        vm.emitOrderRow += 1
        vm.emitProductRow += 1
      })
      this.resetOrderCheckbox(order)
      // vm.componentProductsKey += 1
    },
    showOnCollapse (index) {
      let target = document.getElementsByClassName('collapse-all')
      if (target[0].classList.contains('collapsed')) {
        let collapseOrder = document.getElementById('collapse-order' + index)
        collapseOrder.classList.add('show')
        collapseOrder.style.display = 'block'
      }
    },
    showAllProductsFromOrder (index, id, event) {
      event.stopPropagation()
      let order = this.showAllProductsFromOrderObject.find(order => order.id === id)
      this.orders[index].products = order.products
      this.componentProductsKey += 1
    },
    resetOrderCheckbox (order) {
      let vm = this
      let allCheck = true
      order.products.forEach(function (product) {
        if (product.checked === false) {
          order.checked = false
          allCheck = false
          return false
        }
      })
      if (allCheck) {
        order.checked = true
      }
      vm.emitOrderRow += 1
    },
    emitProduct (orderId, prodId, check = true, prod = null) {
      let order = this.ordersAll.find(o => parseInt(o.id) === parseInt(orderId))
      let orderr = this.orders.find(o => parseInt(o.id) === parseInt(orderId))
      // let product = order.products.find(prods => parseInt(prods.id) === parseInt(prodId)
      // && parseInt(prods.warehouse_id) === parseInt(prod.warehouse_id))

      let productChecked = []
      let filteredInputs = []
      let cloneProduct = _.cloneDeep(prod)

      if (cloneProduct.checked === true) {
        order.products.filter(function (product) {
          if (product.checked === true) {
            productChecked.push(product)
          }
        })
        let inputs = document.querySelectorAll("input[data-product='" + order.id + '-' + prod.id + "']")
        for (let [key, val] of Object.entries(inputs)) {
          let status = val.getAttribute('data-product-can-be-added')
          if (status) {
            filteredInputs.push(val)
          }
        }
        let data = {
          inputs: filteredInputs,
          orderId: order.id,
          product: cloneProduct
        }
        this.$emit('addItem', data)
      } else {
        productChecked.pop()
        let data = {
          orderId: order.id,
          productId: prod.id,
          product: cloneProduct
        }
        this.$emit('removeItemFromOrder', data)
      }
      this.resetOrderCheckbox(orderr)
    },
    orderObjectives () {
      let filter = [...new Set(this.ordersAll.map(o => o.objective))]
      filter = filter.length > 1 ? filter : null
      return filter
    },
    orderObjectives2 () {
      let filters = this.ordersAll.filter(function (order) {
        if (order.objective !== '') {
          order.status = false
          return true
        }
      })
      return filters
    },
    orderDates () {
      let filter = [...new Set(this.ordersAll.map(o => o.created_at))]
      filter = filter.length > 1 ? filter : null
      return filter
    },
    applySearch () {
      if (this.search && this.search !== '') {
        let vm = this
        let orderss = _.cloneDeep(this.ordersAll)
        for (let i = 0; i < orderss.length; i++) {
          orderss[i].products = orderss[i].products.filter(function (product) {
            let keywords = vm.search.trim().replace(/\s+/g, ' ').split(' ')
            for (let j = 0; j < keywords.length; j++) {
              if (product.name.toLowerCase().includes(keywords[j].toLowerCase()) || keywords[j] === '') {
                return true
              }
            }
          })
        }
        let searchOrders = []
        for (let i = 0; i < orderss.length; i++) {
          if (orderss[i].products.length) {
            searchOrders.push(orderss[i])
          }
        }
        this.orders = _.cloneDeep(searchOrders)
      } else {
        this.orders = this.ordersAll
      }
    },
    resetFilter (key, filter) {
      let vm = this
      this.orderFilter[key] = []
      this[filter] += 1
      this.orders = this.ordersAll
      this.applySearch()
      this.orderFilterKeys.forEach(function (element) {
        if (vm.orderFilter[element].length > 0) {
          vm.orders = vm.orders.filter(order => vm.orderFilter[element].includes(order[element]))
        }
      })
    },
    addRemoveFilter: function (key, value) {
      let vm = this
      let index = this.orderFilter[key].indexOf(value)
      if (index === -1) {
        this.orderFilter[key].push(value)
      } else {
        this.orderFilter[key].splice(index, 1)
      }

      this.orders = this.ordersAll
      this.applySearch()
      this.orderFilterKeys.forEach(function (element) {
        if (vm.orderFilter[element].length > 0) {
          vm.orders = vm.orders.filter(order => vm.orderFilter[element].includes(order[element]))
        }
      })
    },
    getUserOrders (id) {
      OrdersService.getUserOrders(id)
        .then((response) => {
          this.ordersAll = response.data.data
          for (let i = 0; i < this.ordersAll.length; i++) {
            this.ordersAll[i]['checked'] = false
            for (let j = 0; j < this.ordersAll[i].products.length; j++) {
              this.ordersAll[i].products[j]['checked'] = false
              let inputVal = null
              if (this.ordersAll[i].products[j].qty_total - this.ordersAll[i].products[j].qty_billed <= this.ordersAll[i].products[j].qty_available) {
                inputVal = this.ordersAll[i].products[j].qty_total - this.ordersAll[i].products[j].qty_billed
              } else {
                inputVal = this.ordersAll[i].products[j].qty_available
              }
              this.ordersAll[i].products[j]['qty_input'] = inputVal > 0 ? inputVal : null
            }
          }
          this.orders = this.ordersAll
          this.showAllProductsFromOrderObject = _.cloneDeep(this.orders)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getWarehousesById (id) {
      return this.warehouses.find(wrh => parseInt(wrh.id) === parseInt(id))
    }
  },
  async created () {

  }
}
</script>
